declare global {
  interface Window {
    Trustpilot?: {
      loadFromElement: (element: HTMLElement, refresh?: boolean) => void;
    };
  }
}

export function initTrustpilotBanner(): void {
  const widgets = document.querySelectorAll<HTMLElement>('.trustpilot-banner .trustpilot-widget');

  if (!widgets.length) {
    return;
  }

  const loadWidgets = (): boolean => {
    if (!window.Trustpilot?.loadFromElement) {
      return false;
    }

    widgets.forEach((widget) => {
      window.Trustpilot?.loadFromElement(widget, true);
    });

    return true;
  };

  if (loadWidgets()) {
    return;
  }

  const intervalId = window.setInterval(() => {
    if (loadWidgets()) {
      window.clearInterval(intervalId);
    }
  }, 100);

  window.setTimeout(() => window.clearInterval(intervalId), 10000);
}
